import { Component, Input, ViewChildren } from '@angular/core';
import { environment } from '../../../.././environments/environment';

@Component({
  selector: 'apc-navbar-big',
  templateUrl: './navbar-big.component.html',
  styleUrls: ['./navbar-big.component.scss'],
})

export class NavbarBigComponent {
  @Input() public items: any[];
  @Input() public color: string;
  @Input() public permission: string;
  @ViewChildren("linkMenu") linkMenu:any;
  
  constructor() { }
  public envType = environment.key

  ngAfterViewInit() {
    var menusLinks = this.linkMenu;
    if(menusLinks._results && menusLinks._results.length >0){
      menusLinks._results[0].nativeElement.classList.add("back-button");
      if (menusLinks._results[0].nativeElement.id == 'BACK' && menusLinks._results.length >= 2 && !window.location.pathname.split('/')[4]) {
        menusLinks._results[1].nativeElement.click();
      }
    }
  }
}
